import { Send } from '@ori-ui/icons';
import { Typography } from '@ori-ui/mui';
import { useDisclose } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';
import Cookies from 'js-cookie';
import type { FC } from 'react';
import React, { useCallback, useState } from 'react';

import { cookieExpireDays, newsletterPopupCookieKey, newsletterPopupCookieValue } from '../../constants';
import { useFooter, useSubscribePopup } from '../../hooks';
import { NewsletterDialog } from './components/NewsletterDialog/NewsletterDialog';
import { NewsletterDialogContextProvider } from './components/NewsletterDialog/components';
import { Origin } from './components/NewsletterDialog/types';
import { SUBSCRIBE } from './constants';
import { IconRoot, Root } from './styles';

export const Subscribe: FC = () => {
  const { getTestId } = useTestId();
  const { newsletterSubsciptionConfiguration, isMobileOffice } = useFooter();
  const { footer, popup } = newsletterSubsciptionConfiguration ?? {};

  const { onClose, onOpen, open } = useDisclose();
  const [origin, setOrigin] = useState<Origin>(Origin.OnlinePopup);

  useSubscribePopup({ open, onOpen, footer, popup });

  const openDialog = useCallback(() => {
    Cookies.set(newsletterPopupCookieKey, newsletterPopupCookieValue, {
      expires: popup?.displayFrequencyInDays ?? cookieExpireDays,
    });
    setOrigin(Origin.OnlineFooter);
    onOpen();
  }, [popup?.displayFrequencyInDays, onOpen]);

  if (!footer?.enabled) {
    return null;
  }

  return (
    <>
      <Root
        data-testid={getTestId(SUBSCRIBE)}
        role="button"
        tabIndex={0}
        isMobileOfficeFull={isMobileOffice}
        onClick={openDialog}
      >
        <IconRoot>
          <Send fontSize="inherit" />
        </IconRoot>
        <Typography
          variant="subtitle1"
          component="h6"
          align="center"
          color="white"
          fontWeight="bold"
        >
          {footer.title}
        </Typography>
      </Root>
      <NewsletterDialogContextProvider>
        <NewsletterDialog
          open={open}
          origin={origin}
          onClose={onClose}
        />
      </NewsletterDialogContextProvider>
    </>
  );
};
